import _extends from "@babel/runtime/helpers/extends";
/*
 *                     NOTICE
 *            COPYRIGHT 2021 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */
import { AbInlineNotification } from "abreact/feedback/AbInlineNotification";
import * as AbReactResources from "abreact/generated/locale/AbReactResources";
import { AbErrorDialog } from "abreact/incubator/ui/error/AbErrorDialog";
import { ReactUtils } from "abreact/incubator/ui/utils/ReactUtils";
import { AbReactServices } from "abreact/service/AbReactServices";
import { LogUtils } from "abweb/utils/log/LogUtils";
import * as React from "react";
const LOG = LogUtils.getLogger(__filename);
export function AbInlineErrorNotification(props) {
  // ABSDK-3779: Added ab-flexible. Remove if unneeded here.
  return /*#__PURE__*/React.createElement(AbInlineNotification, _extends({}, ReactUtils.componentProps("ab-inline-error-notification", props, ["ab-flexible"]), {
    dataTestId: props.dataTestId,
    severity: "error",
    message: props.message ?? AbReactResources.error_unexpectedInternalError(),
    buttons: props.buttons,
    onDetails: () => showErrorDialog(props.error)
  }));
}
function showErrorDialog(error) {
  try {
    if (AbReactServices.isInitialized()) {
      // Requires 'abweb' and 'abreact' loaded resources to render
      AbErrorDialog.displayError(error).then();
    } else {
      // Whoa - error boundary caught rendering error before the even completing abweb and abreact initialization!
      // Should never happen. But just in case, splat some useful (ugly) info onto the screen with an alert...
      serializeAndAlert(error, error => [String(error), `Stack Trace: ${error.stack}`].join("\n"));
    }
  } catch (err) {
    LOG.error("Error while attempting to display error caught by ErrorBoundary: " + err?.toString());
    // Fallback: try to render details of original error with minimal info that should be safe to render in all situations
    serializeAndAlert(error, error => error.message);
  }
}
function serializeAndAlert(error, serialize) {
  alert(Array.isArray(error) ? error.map((error, index) => `#${index}: ${serialize(error)}`).join("\n\n") : serialize(error));
}
//# sourceMappingURL=AbInlineErrorNotification.js.map
